export const blockIconsSearchTableRestaurant = (
	<span className='material-symbols-outlined'>table_restaurant</span>
);
